import { InlineWidget } from 'react-calendly';
import { Modal } from '../../../atoms/modal';

export interface IProps {
  url: string;
  prefill: IPrefill;
  styles?: ITheme;
}

export interface IDispatchProps {
  onClose: () => void;
}

interface ITheme {
  minWidth: string;
  height: string;
}

export interface IPrefill {
  name: string;
  email: string;
  firstName: string;
  lastName: string;
}

const CalendlyWidget: React.FC<IProps & IDispatchProps> = (props: IProps & IDispatchProps) => {
  return (
    <>
      <Modal
        id={'calendly-inline-widget'}
        show={true}
        onClose={props.onClose}
        maxWidthPx={650}
        hideFooter={true}
        withoutPadding={true}
        paddingTop={2}
      >
        <InlineWidget url={props.url} prefill={props.prefill} styles={props.styles || defaultStyles} />
      </Modal>
    </>
  );
};

const defaultStyles = {
  height: '550px',
  padding: '2px'
};

export default CalendlyWidget;
